<template>
  <div class="main_body contact_page">
    <section id="hero_section">
      <div class="container">
        <navbar></navbar>
        <div class="main_logo">
          <img src="@/assets/images/Logo-011.png" alt="Logo-011.png">
        </div>
        <section class="contact_section">
          <div class="heading_section">
            <h3>Please verify your email first</h3>
            <div v-if="this.$store.getters.apiStatus === 'loading'" class="loader">
              <h4>
                <div class="d-flex">
                  Sending verification email
                  <Loader />
                </div>
              </h4>
            </div>
            <div v-else>
              <h4>{{message}}</h4>
            </div>
          </div>

        </section>

      </div>
    </section>
  </div>
</template>

<script>
export default {
  name: 'VerifyEmail',
  data () {
    return {
      message: ''
    }
  },
  created () {
    if (this.$store.getters.isEmailVerified) {
      this.$router.push('/')
      this.$toast.success('Your email has already been verified')
    }
    this.$store
      .dispatch('verifyEmailRequest')
      .then((resp) => {
        this.message = resp.data.message
      })
      .catch((err) => {
        console.log(err.response.data.message)
        if (err.response.data.message === 'Too Many Attempts.') {
          this.message = 'An email has already been sent.'
        } else {
          this.$helper.catchHandler(err)
        }
      })
  }
}

</script>

<style scoped>
  h4 {
    text-transform: none;
  }

</style>



// WEBPACK FOOTER //
// src/views/VerifyEmail.vue